import { render } from "./payment-popup.vue?vue&type=template&id=4fa0c8b5&scoped=true&ts=true"
import script from "./payment-popup.vue?vue&type=script&lang=ts"
export * from "./payment-popup.vue?vue&type=script&lang=ts"

import "./payment-popup.vue?vue&type=style&index=0&id=4fa0c8b5&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa0c8b5"]])

export default __exports__